import { config } from '../../../../config';
import { readUtmParams } from '../../../../services/tracking/helpers/utmParams';
import type { UtmParameters } from '../../../../services/tracking/helpers/utmParams';
import { getPreviousPageViewOrigin } from '../../../../services/tracking/helpers/pulseOrigin';
import { parseSDRN } from '../../../../services/tracking/helpers/getSDRN';
import type { PulseEventOrigin } from '../../../../services/tracking/pulse';

const getUtmParamsFromOrigin = (
  origin: PulseEventOrigin
): UtmParameters | undefined => {
  const result = origin['@id'] ? parseSDRN(origin['@id']) : undefined;

  if (result?.objectType === 'video' && result.id) {
    return {
      utm_source: 'vgtv-video',
      utm_content: result.id,
    };
  }

  return undefined;
};

const getUtmParams = () => {
  const utmParams = readUtmParams();

  // utm parameters in the url always take precedence
  if (Object.keys(utmParams).length > 0) {
    return utmParams;
  }

  const origin = getPreviousPageViewOrigin();

  if (origin) {
    return getUtmParamsFromOrigin(origin);
  }

  return undefined;
};

function getPurchaseUrl(
  entityId: string,
  overrides: Partial<Record<string, string>> = {}
) {
  const utmParams = getUtmParams();

  const params = new URLSearchParams({
    ...utmParams,
    publisher: 'vg',
    client_id: config.schibstedAccount.clientId,
    type: 'video',
    content_id: entityId,
    redirect_uri: `${window.location.origin}/login-callback`,
    state: window.location.pathname,
    ...overrides,
  });

  return `https://${config.schibstedAccount.realmDomain}/authn/payment/purchase/code?${params}`;
}

export { getPurchaseUrl };
